const colors = {
	subtle: {
		"700": "#B94F19",
		"600": "#DA7D49",
		"500": "#EDA276",
		"400": "#F8C5A3",
		"300": "#F7DAC4",
		"200": "#F5E8DC",
		"100": "#FFFAF0"
	},
	emphasis: {
		"700": "#6B46C1",
		"700-a33": "rgba(107, 70, 193, 0.33)",
		"200": "#E9D8FD",
		"100": "#FAF5FF"
	},
	grey: {
		"900": "#1A202C",
		"600": "#718096",
		"400": "#CBD5E0",
		"300": "#E2E8F0",
		"200": "#EDF2F7",
		"100": "#F7FAFC"
	},
	white: "#FFF"
};

module.exports = {
	colors
};
